import React from 'react'
import w from 'lib/styleguide/widgets.scss'
import cx from 'classnames'
import _ from 'lodash'
import { CoreLink } from 'common/CoreLink'

const availableVariations = ['link', 'small', 'primary', 'danger', 'secondary', 'facebook']

const getCTATypeClass = (props) => {
  // find the first variation that occurs in props
  const variations = availableVariations.filter(v => props[v])
  return variations.length > 0
    ? variations.map(v => w[v + 'CTA']).join(' ')
    : w.primaryCTA
}
// there's a reason you can't inject a className here. just use a wrapper.
// this is not a stateless component in order to enable refs
export const CTA = React.forwardRef((props, ref) => {
  const { inline, style, disabled, button, className, ...rest } = props
  let { margins } = props
  if (margins === undefined) { margins = true }

  const type = getCTATypeClass(rest)
  const cn = cx(
    w.CTA,
    inline && w.inlineCTA,
    type,
    className,
    disabled && w.disabled
  )
  // support margins={false} AND style overrides
  const _style = margins
    ? style
    : { margin: '0 0', ...style }
  const safeProps = _.omit(rest, availableVariations)
  const allProps = { className: cn, style: _style, ...safeProps }
  return button ? <button ref={ref} {...allProps} /> : <CoreLink ref={ref} {...allProps} />
})
